module.exports = __webpack_public_path__ + "static/whatsapp-dark-b91998b29feaa3ca5d96a1d15019a41b.png";